import { CommunityDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadCommunity = createAction('[Community] Load Community');

export const loadCommunitySuccess = createAction(
  '[Community] Load Community Success',
  props<{ community: CommunityDto[] }>()
);

export const loadCommunityFailure = createAction(
  '[Community] Load Community Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addCommunity = createAction(
  '[Community] Add Community',
  props<{ newCommunity: CommunityDto[] }>()
);

export const addCommunitySuccess = createAction(
  '[Community] Add Community Success',
  props<{ newCommunity: CommunityDto[] }>()
);

export const addCommunityFailure = createAction(
  '[Community] Add Community Failure',
  props<{ error: any }>()
);

/**
 * Update Community Collection Actions
 */
export const updateCommunity = createAction(
  '[Community] Update Community',
  props<{ updateCommunity: CommunityDto[] }>()
);

export const updateCommunitySuccess = createAction(
  '[Community] Update Community Success',
  props<{ updateCommunity: CommunityDto[] }>()
);

export const updateCommunityFailure = createAction(
  '[Community] Update Community Failure',
  props<{ error: any }>()
);

/**
 * Remove Community Collection Actions
 */
export const removeCommunity = createAction(
  '[Community] Remove Community',
  props<{ ids: string[] }>()
);

export const removeCommunitySuccess = createAction(
  '[Community] Remove Community Success',
  props<{ ids: string[] }>()
);

export const removeCommunityFailure = createAction(
  '[Community] Remove Community Failure',
  props<{ error: any }>()
);
